
















import { computed, defineComponent, ref } from "@vue/composition-api";
import appStorage, { AppSessionStorage } from "@/lib/appStorage";
import { getPWAPrompt, removePWAPrompt } from "@/lib/pwa";
import { STORAGE } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "BannerPWA",
  components: { BaseIconButton, BaseButton },
  setup() {
    let PWAPrompt = getPWAPrompt();
    const forceHidden = ref(appStorage.getBoolean(STORAGE.FORCE_HIDE_PWA_BANNER, false));
    const hidden = ref(AppSessionStorage.getBoolean(STORAGE.HIDE_PWA_BANNER, false));
    const show = computed(() => !forceHidden.value && !hidden.value && PWAPrompt);

    const setForceHide = () => {
      forceHidden.value = true;
      appStorage.setBoolean(STORAGE.FORCE_HIDE_PWA_BANNER, true);
    };

    const setHide = () => {
      hidden.value = true;
      AppSessionStorage.setBoolean(STORAGE.HIDE_PWA_BANNER, true);
    };

    const install = async () => {
      if (!PWAPrompt) return;
      await PWAPrompt.prompt();
      removePWAPrompt();
      hidden.value = true;
    };

    return {
      show,
      setHide,
      setForceHide,
      install,
    };
  },
});
